import React, { FC } from 'react';
import { Formik, FormikHelpers } from 'formik';

import { DepartmentLocationSchema } from 'features/admin/validations';
import { ICreateDepartmentLocation, IDepartmentsLocationsOptions } from 'features/admin/types';

import CreateForm from './CreateForm';

interface IProps extends IDepartmentsLocationsOptions {
  titleKey: string;
  inputPlaceholderKey: string;
}

const Create: FC<IProps> = props => {
  const { createAsyncMutation, activeDepartmentStatus, activeLocationStatus, ...rest } = props;
  const initialValues = {
    title: '',
  };

  async function handleSave(
    { title }: ICreateDepartmentLocation,
    helpers: FormikHelpers<ICreateDepartmentLocation>
  ) {
    const data = { title, ...activeDepartmentStatus, ...activeLocationStatus };
    helpers.resetForm();

    await createAsyncMutation({ data });
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSave}
      validationSchema={DepartmentLocationSchema}
    >
      <CreateForm {...rest} />
    </Formik>
  );
};

export default Create;
